import React from "react";
import { useTranslation } from "react-i18next";
import CustomTitleTerms from "./customTitleTerms";
import CustomTermPoints from "./customTermPoints";
import CustomTermWithoutPoints from "./customTermWithoutPoints";

const ContainerTerms = () => {
  const { t, i18n } = useTranslation();

  // Check if the current language is Arabic
  const isRTL = i18n.language === "ar";

  return (
    <div className="px-4 py-3 lg:px-0 lg:py-8">
      <div
        className={`max-container ${isRTL ? "rtl" : "ltr"}`} // Set direction
        dir={isRTL ? "rtl" : "ltr"} 
      >
        <div
          className={` ${
            isRTL ? "text-right" : "text-left"
          }  lg:mx-0  py-6 lg:py-10  flex flex-col gap-y-2`}
        >
          {/* Privacy Policy */}
          <CustomTitleTerms title={t("privacyPolicyTitle")} first={true} />
          <CustomTermPoints title={t("privacyPolicyPoint1")} />
          <CustomTermPoints title={t("privacyPolicyPoint2")} />
          <CustomTermPoints title={t("privacyPolicyPoint3")} />
          <CustomTermPoints title={t("privacyPolicyPoint4")} />
          <CustomTermPoints title={t("privacyPolicyPoint5")} />
          <CustomTermPoints title={t("privacyPolicyPoint6")} />
          <CustomTermPoints title={t("privacyPolicyPoint7")} />
          <CustomTermPoints title={t("privacyPolicyPoint8")} />
          <CustomTermPoints title={t("privacyPolicyPoint9")} />

          {/* Consent for Data Transfer */}
          <CustomTitleTerms title={t("consentDataTransferTitle")} />
          <CustomTermPoints title={t("consentDataTransferPoint1")} />
          <CustomTermPoints title={t("consentDataTransferPoint2")} />
          <CustomTermPoints title={t("consentDataTransferPoint3")} />
          <CustomTermPoints title={t("consentDataTransferPoint4")} />

          {/* Data Collection and Usage */}
          <CustomTitleTerms title={t("dataCollectionTitle")} />
          <CustomTermPoints title={t("dataCollectionPoint1")} />
          <CustomTermPoints title={t("dataCollectionPoint2")} />
          <div className="flex flex-col md:ps-9 ps-6 gap-y-3">
            <CustomTermWithoutPoints title={t("dataCollectionPoint3")} />
            <CustomTermWithoutPoints title={t("dataCollectionPoint4")} />
            <CustomTermWithoutPoints title={t("dataCollectionPoint5")} />
            <CustomTermWithoutPoints title={t("dataCollectionPoint6")} />
            <CustomTermWithoutPoints title={t("dataCollectionPoint7")} />
            <CustomTermWithoutPoints title={t("dataCollectionPoint8")} />
            <CustomTermWithoutPoints title={t("dataCollectionPoint9")} />
            <CustomTermWithoutPoints title={t("dataCollectionPoint10")} />
          </div>

          {/* Data Usage and Disclosure */}
          <CustomTitleTerms title={t("dataUsageDisclosureTitle")} />
          <CustomTermPoints title={t("dataUsageDisclosurePoint1")} />
          <CustomTermPoints title={t("dataUsageDisclosurePoint2")} />
          <CustomTermPoints title={t("dataUsageDisclosurePoint3")} />
          <CustomTermPoints title={t("dataUsageDisclosurePoint4")} />

          {/* Data Removal Requests */}
          <CustomTitleTerms title={t("dataRemovalTitle")} />
          <CustomTermPoints title={t("dataRemovalPoint1")} />
          <CustomTermPoints title={t("dataRemovalPoint2")} />
          <CustomTermPoints title={t("dataRemovalPoint3")} />
          <CustomTermPoints title={t("dataRemovalPoint4")} />
          <CustomTermPoints title={t("dataRemovalPoint5")} />

          {/* Privacy Policy Updates */}
          <CustomTitleTerms title={t("policyUpdatesTitle")} />
          <CustomTermPoints title={t("policyUpdatesPoint1")} />
          <CustomTermPoints title={t("policyUpdatesPoint2")} />
          <CustomTermPoints title={t("policyUpdatesPoint3")} />
          <CustomTermPoints title={t("policyUpdatesPoint4")} />
          <CustomTermPoints title={t("policyUpdatesPoint5")} />
          <CustomTermPoints title={t("policyUpdatesPoint6")} />
        </div>
      </div>
    </div>
  );
};

export default ContainerTerms;
